'use client'

import { track } from '@vercel/analytics'

export type LandingEventName =
  | 'view_landing'
  | 'projects_new_view'
  | 'project_registration_completed'
  | 'click_cta_hero_primary'
  | 'click_cta_promo_primary'
  | 'click_cta_bottom_primary'
  | 'click_secondary_explore'
  | 'click_public_inquiry_channel'
  | 'keyword_saved'
  | 'onboarding_start'
  | 'public_inquiry_created'
  | 'hero_quick_start_submit'
  | 'hero_quick_start_category_selected'
  | 'projects_new_prefill_applied'

export function trackLandingEvent(eventName: LandingEventName, properties?: Record<string, string | number | boolean>) {
  try {
    track(eventName, properties)
  } catch {
    // no-op: tracking failures should never block UX
  }
}
